import React from "react";
import MetaTags from "../components/common/MetaTags";

const PageNotFound = () => {
  return (
    <div className="w-full h-screen flex flex-col justify-center items-center bg-custom-gray-100">
      <MetaTags
        title="Page Not Found!"
        description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
        noIndex
      />
      <h1 className="text-5xl abel-font">404</h1>
      <p className="text-2xl mt-5">Oops! Page Not Found!</p>
    </div>
  );
};

export default PageNotFound;
